export * from './login_link'
export * from './search'

import '../shared/translation_setup'
// this file is auto-generated. to update it
// with content from the yml files,
// restart server or run `rake i18n:js:export`
export * from './translations'
